import LoginWrapper from './LoginWrapper';

export default LoginWrapper;
